<template>
  <div class="drawer-wrapper"
       @mouseenter="startHoverDelay"
       @mouseleave="cancelHover">
    <v-navigation-drawer v-model="drawer"
                         :mini-variant="mini"
                         :width="drawerWidth"
                         :expand-on-hover="false"
                         hide-overlay
                         dark
                         permanent
                         absolute
                         class="drawer"
                         :class="formatedCurrentContext.drawerClass">
      <template #prepend>
        <v-list>
          <v-fade-transition>
            <v-list-item class="px-2">
              <v-list-item-avatar>
                <v-img :src="'./' + formatedCurrentContext.logo" />
              </v-list-item-avatar>
              <v-row class="pa-2">
                <v-list-item-content>
                  <v-list-item-title>
                    <b>{{ userProfile.firstName }} {{ userProfile.lastName }}</b>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ userProfile.email }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-row>
            </v-list-item>
          </v-fade-transition>
        </v-list>
      </template>

      <v-divider />

      <div class="drawer-scrollable">
        <v-list>
          <template v-for="group in groupsFiltered">
            <v-list-group :key="'group-' + group.id">
              <template #activator>
                <v-list-item-action class="group-wrapper">
                  <v-icon class="group-icon"
                          :class="{ active: isChildActive(group) }">
                    {{ group.icon }}
                  </v-icon>
                </v-list-item-action>
                <v-slide-x-transition>
                  <v-list-item-title v-if="expanded"
                                     class="group-title"
                                     :class="{ active: isChildActive(group) }">
                    {{ group.title }}
                  </v-list-item-title>
                </v-slide-x-transition>
              </template>

              <v-list-item v-for="link in linkFiltered(group.id)"
                           :key="link.title"
                           class="link"
                           :class="{ active: isActive(link) }"
                           @click="navigate(link)">
                <v-list-item-action class="link-wrapper">
                  <v-icon class="link-icon" :class="{ active: isActive(link) }">
                    {{ link.icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-slide-x-transition>
                    <v-list-item-title v-if="expanded" class="link-text">
                      {{ link.title }}
                    </v-list-item-title>
                  </v-slide-x-transition>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-divider :key="'divider-' + group.id" />
          </template>
        </v-list>
      </div>

      <div class="drawer-bottom">
        <!-- No more Yuccan -->
        <!-- <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-list-item class="yuccan-list-item drawer-footer-yuccan"
                         v-bind="attrs"
                         v-on="on"
                         @click="yuccanDialog = true">
              <v-list-item-action>
                <v-icon class="confetti-icon">
                  card_giftcard
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-slide-x-transition>
                  <v-list-item-title v-if="expanded" class="link-text">
                    Parrainage
                  </v-list-item-title>
                </v-slide-x-transition>
              </v-list-item-content>
            </v-list-item>
          </template>
          <span>Parrainez un magasin et gagnez 150€!</span>
        </v-tooltip> -->

        <router-link class="drawer-footer" to="/config">
          <v-icon size="40" class="settings-icon">
            settings
          </v-icon>
        </router-link>
      </div>
    </v-navigation-drawer>
    <v-dialog v-model="yuccanDialog" width="900" persistent scrollable>
      <v-card>
        <v-toolbar dense flat>
          <v-toolbar-title>
            <span class="yuccan-toolbar-title">
              Parrainage Hublot & Yuccan
            </span>
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="yuccanDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text style="padding: 0; height: 80vh">
          <iframe src="https://www.yuccanlead.com/w/hublot"
                  style="border: none; width: 100%; height: 100%" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import {carnotDrawer, hublotDrawer} from '@/utils/drawer'

import {contextDatas, contexts} from '../store/context'

export default {
  name: 'Navigation',
  data() {
    return {
      drawer: true,
      mini: true,
      expanded: false,
      hoverTimeout: null,
      selectedGroupId: '',
      groups: [],
      links: [],
      miniWidth: 80,
      fullWidth: 280,
      yuccanDialog: false
    }
  },
  computed: {
    drawerWidth() {
      return this.expanded ? this.fullWidth : this.miniWidth
    },
    formatedCurrentContext() {
      return contextDatas.find(c => c.id === this.currentContext)
    },
    groupsFiltered() {
      return this.userType === 6 ? this.groups.filter(group => group.type === 'common') : this.groups
    },
    ...mapState({
      currentContext: state => state.context.currentContext,
      userProfile: state => state.authentication.userProfile,
      userType: state => state.authentication.client.idenseigne
    })
  },
  watch: {
    currentContext() {
      this.updateDrawerContent()
    }
  },
  created() {
    this.updateDrawerContent()
  },
  methods: {
    updateDrawerContent() {
      if (this.currentContext === contexts.BOUCHERIE_CONTEXT) {
        this.groups = carnotDrawer.groups
        this.links = carnotDrawer.links
      } else {
        this.groups = hublotDrawer.groups
        this.links = hublotDrawer.links
      }
    },
    linkFiltered(id) {
      return this.links.filter(link => link.idGroup === id)
    },
    isActive(link) {
      return link.to === this.$route.path
    },
    isChildActive(group) {
      return group.id === this.selectedGroupId
    },
    navigate(link) {
      this.selectedGroupId = link.idGroup
      this.$router.push({path: link.to})
    },
    startHoverDelay() {
      this.hoverTimeout = setTimeout(() => {
        this.mini = false
        this.expanded = true
      }, 300)
    },
    cancelHover() {
      clearTimeout(this.hoverTimeout)
      this.mini = true
      this.expanded = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars";
@import "@/assets/fonts/style.css";

.drawer-wrapper {
  transition: width 0.3s ease-in-out;
}
.drawer {
  transition: width 0.3s ease-in-out;
  position: absolute;
  z-index: 10;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.drawer ::v-deep .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.drawer-scrollable {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  max-height: 100%;
}

.drawer-bottom {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

/* Layout horizontal pour les boutons du bas */
.drawer-bottom-horizontal {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 8px;
}

.bottom-button-left {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
}

.bottom-button-right {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
}

/* Styles pour le menu réduit (mini-variant) */
.v-navigation-drawer--mini-variant .drawer-bottom-horizontal {
  justify-content: center;
  flex-direction: column;
  height: 100px;
  padding: 5px;
}

.v-navigation-drawer--mini-variant .bottom-button-left,
.v-navigation-drawer--mini-variant .bottom-button-right {
  flex: none;
  width: 40px;
  height: 40px;
  margin: 2px 0;
  justify-content: center;
}

.v-navigation-drawer--mini-variant .bottom-button-left .yuccan-list-item {
  min-width: 40px;
  padding: 0;
  justify-content: center;
}

.v-navigation-drawer--mini-variant .bottom-button-left .link-text {
  display: none !important;
}

.v-navigation-drawer--mini-variant .settings-icon {
  font-size: 24px !important;
}

.v-navigation-drawer--mini-variant .confetti-icon {
  font-size: 20px !important;
}

.settings-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.settings-link:hover {
  transform: scale(1.1);
  background: rgba(255, 255, 255, 0.1);
}

.yuccan-list-item {
  color: white;
  min-height: 60px;
  padding: 0 8px;
}

.yuccan-toolbar-title {
  font-family: "Paytone One", sans-serif;
  color: $primary;
  font-size: 1.5rem;
  margin: 0;
}
.yuccan-title {
  font-size: 14px;
  font-weight: 500;
  color: white;
  text-align: left;
  padding-left: 0 !important;
}

.group-title {
  display: inline-flex;
  align-items: center;
  min-height: 50px;
  margin-left: -20px;
  font-size: 1.1rem;
  color: white;
  font-weight: 600;
  text-transform: uppercase;
  transition: transform 0.3s ease-in-out;
}
.group-title:hover {
  font-weight: 900;
  letter-spacing: 1px;
  cursor: pointer;
}
.group-title.active {
  opacity: 0.7;
  font-size: 1.2rem;
}
.group-icon.active {
  font-size: 2rem !important;
  margin-left: -2px;
}
.group-wrapper {
  min-height: 50px;
  max-width: 50px;
}
.group-icon {
  color: white !important;
}
.link {
  border-left: 5px solid transparent;
  font-size: 14px;
  color: white;
  height: 45px;
  width: 100%;
  display: flex;
  align-items: center;
}

/* Media queries pour petits écrans - menus plus compacts */
@media (max-height: 700px) {
  .drawer-scrollable {
    padding-bottom: 80px; /* Espace pour le layout horizontal */
    max-height: calc(100vh - 150px);
    overflow-y: auto;
  }
  
  .group-title {
    min-height: 40px;
    font-size: 1rem;
  }
  
  .group-wrapper {
    min-height: 40px;
  }
  
  .link {
    height: 38px;
    font-size: 13px;
  }
}

@media (max-height: 600px) {
  .drawer-scrollable {
    padding-bottom: 80px;
    max-height: calc(100vh - 160px);
  }
  
  .group-title {
    min-height: 35px;
    font-size: 0.9rem;
    font-weight: 500;
  }
  
  .group-wrapper {
    min-height: 35px;
  }
  
  .link {
    height: 32px;
    font-size: 12px;
  }
  
  .drawer-bottom-horizontal {
    height: 50px;
    bottom: 8px;
  }
  
  .yuccan-list-item {
    min-height: 50px;
    font-size: 13px;
  }
  
  .settings-icon {
    font-size: 35px !important;
  }
}

@media (max-height: 500px) {
  .drawer-scrollable {
    padding-bottom: 70px;
    max-height: calc(100vh - 180px);
  }
  
  .group-title {
    min-height: 30px;
    font-size: 0.8rem;
    font-weight: 500;
  }
  
  .group-wrapper {
    min-height: 30px;
  }
  
  .link {
    height: 28px;
    font-size: 11px;
  }
  
  .drawer-bottom-horizontal {
    height: 45px;
    bottom: 5px;
  }
  
  .yuccan-list-item {
    min-height: 45px;
    font-size: 12px;
  }
  
  .settings-icon {
    font-size: 30px !important;
  }
  
  .confetti-icon {
    font-size: 18px !important;
  }
}
.link:hover .link-text {
  font-weight: 500;
}
.link.active {
  border-color: white;
}

.link-text {
  transition: transform 0.5s ease-in-out;
}
.drawer-boucherie {
  background: linear-gradient(#9d0419, #f35963) !important;

  .link-icon.active {
    color: #f35963;
  }

  .link-text.active {
    color: #f35963;
  }
}
.drawer-poissonnerie {
  background: linear-gradient(#23414d, #407286) !important;
  .link-icon.active {
    color: #8ac3d5;
  }
  .link-text.active {
    color: #8ac3d5;
  }
}
</style>
